// extracted by mini-css-extract-plugin
export default {"action":"styles-module__action__src-labstep-web-grid-SmartTable-coldefs-_P1miR"};